import { useEffect, useState } from "react";
import { PreviewButton } from "@/components/PdfPreview";
import { History, FileDown, Pencil } from "lucide-react";
import api, { download } from "@/lib/api";
import { fdate } from "@/lib/fmt";
import { RiskBadge } from "@/components/Common";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const picText = (a) => (a.pics?.length ? a.pics : [{ name: a.pic_name, position: a.pic_position }]).map((p) => `${p.name}${p.position ? ` (${p.position})` : ""}`).join(", ");

export const ActivityHistoryDialog = ({ activityId, onOpenChange, onEdit }) => {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    if (activityId) api.get(`/activities/${activityId}/history`).then((r) => setRows(r.data));
  }, [activityId]);
  return (
    <Dialog open={!!activityId} onOpenChange={onOpenChange}>
      <DialogContent aria-describedby={undefined} className="max-w-2xl max-h-[85vh] overflow-y-auto">
        <DialogHeader><DialogTitle className="font-heading flex items-center gap-2"><History className="h-5 w-5 text-blue-800" />Riwayat Kunjungan {rows[0]?.customer_name}</DialogTitle></DialogHeader>
        <PreviewButton size="sm" url="/activities-print" params={{ ids: activityId }} filename="Laporan-Kunjungan.pdf" title="Laporan Kunjungan" testId="activity-history-preview-btn" />
        <Button size="sm" variant="outline" className="w-fit bg-white" onClick={() => download("/activities-print", { ids: activityId }, "Laporan-Kunjungan.pdf")} data-testid="activity-history-print-btn"><FileDown className="h-4 w-4 mr-1" />Print Laporan</Button>
        <ol className="relative ml-3 space-y-4 border-l-2 border-blue-100" data-testid="activity-history-timeline">
          {rows.map((a, i) => (
            <li key={a.id} className="ml-6" data-testid={`activity-history-item-${i}`}>
              <span className="absolute -left-[9px] mt-1.5 h-4 w-4 rounded-full border-2 border-white bg-blue-800" />
              <div className="card-premium p-4 text-sm">
                <div className="flex flex-wrap items-center justify-between gap-2">
                  <span className="font-semibold">Progress {a.progress_no || 1}/{a.progress_total || rows.length} • {fdate(a.visit_date)}</span>
                  <span className="flex items-center gap-2"><RiskBadge level={a.risk_level} /><span className="text-xs font-semibold">{a.status}</span>{onEdit && <Button size="sm" variant="ghost" className="h-7 px-2 text-blue-800" onClick={() => onEdit(a)} data-testid={`activity-history-edit-${i}`}><Pencil className="h-3.5 w-3.5 mr-1" />Edit</Button>}</span>
                </div>
                <p className="mt-1 text-xs text-slate-500">PIC: {picText(a)} {a.location ? `• ${a.location}` : ""}</p>
                {a.result && <p className="mt-2">{a.result}</p>}
                {a.risk_notes && <p className="mt-1 text-xs text-amber-700">Resiko: {a.risk_notes}</p>}
                {(a.next_action || a.next_follow_up) && <p className="mt-1 text-xs text-slate-500">Next: {a.next_action} {a.next_follow_up ? `(${fdate(a.next_follow_up)})` : ""}</p>}
              </div>
            </li>
          ))}
        </ol>
      </DialogContent>
    </Dialog>
  );
};

export { picText };
